import { ScholarshipAwardDurationDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScholarshipAwardDurationService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getScholarshipAwardDuration(): Observable<ScholarshipAwardDurationDto[]> {
    return this.http.get<ScholarshipAwardDurationDto[]>(
      this.url + 'scholarship-duration'
    );
  }

  createScholarshipAwardDuration(
    data: ScholarshipAwardDurationDto[]
  ): Observable<ScholarshipAwardDurationDto[]> {
    return this.http.post<ScholarshipAwardDurationDto[]>(
      this.url + 'scholarship-duration',
      data
    );
  }
  getSingleScholarshipAwardDuration(id: string): Observable<any> {
    return this.http.get(this.url + 'scholarship-duration/' + id);
  }

  updateScholarshipAwardDuration(
    data: ScholarshipAwardDurationDto[]
  ): Observable<ScholarshipAwardDurationDto[]> {
    return this.http.post<ScholarshipAwardDurationDto[]>(
      this.url + 'scholarship-duration/update',
      data
    );
  }

  deleteScholarshipAwardDuration(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('scholarship-duration', ids.join(', '));
    return this.http.delete(this.url + 'scholarship-duration', httpOptions);
  }
}
